export default __webpack_public_path__ + "static/media/help_background.f74b8bf6.svg";